import { render, staticRenderFns } from "./BookMarkIcon.vue?vue&type=template&id=758c0efa&scoped=true"
import script from "./BookMarkIcon.vue?vue&type=script&lang=js"
export * from "./BookMarkIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758c0efa",
  null
  
)

export default component.exports